import * as angular from "angular";
import {IController, IScope, IWindowService} from "angular";

export class AgentAvatarCtrl implements IController {

  item: any;

  constructor(private $scope: IScope, private $injector, private $mdSidenav, private $state,
              private $filter, private $window: IWindowService) {
  }

  $onInit() {
    this.item.template = 'app/triangular/components/menu/menu-item-' + this.item.type + '.tmpl.html';

    switch (this.item.type) {
      case 'dropdown':
        // if we have kids reorder them by priority
        this.item.children = this.$filter('orderBy')(this.item.children, 'priority');
        // add a check for open event
        this.$scope.$on('toggleDropdownMenu', (event, item, open) => {
          // if this is the item we are looking for
          if (this.item === item) {
            this.item.open = open;
          } else {
            this.item.open = false;
          }
        });
        // this event is emitted up the tree to open parent menus
        // $scope.$on('openParents', function() {
        //     // openParents event so open the parent item
        //     triMenuItem.item.open = true;
        //     // also add this to the breadcrumbs
        //     triBreadcrumbsService.addCrumb(triMenuItem.item);
        // });
        break;
      case 'link':

        // on init check if this is current menu
        this.checkItemActive();
        // this.checkItemActive(this.$state.current.name, this.$state.params);

        this.$scope.$on('$stateChangeSuccess', (event, toState, toParams) => {
          this.checkItemActive();
          // this.checkItemActive(toState.name, toParams);
        });
        break;
    }
  }

  checkItemActive() {
    // first check if the state is the same
    this.item.active = this.$state.includes(this.item.state, this.item.params);
    // if we are now the active item reset the breadcrumbs and open all parent dropdown items
    if (this.item.active) {
      // triBreadcrumbsService.reset();
      // triBreadcrumbsService.addCrumb(triMenuItem.item);
      this.$scope.$emit('openParents');
    }
  }

  toggleDropdownMenu() {
    this.$scope.$parent.$parent.$broadcast('toggleDropdownMenu', this.item, !this.item.open);
  }

  openLink() {
    if (angular.isDefined(this.item.click)) {
      this.$injector.invoke(this.item.click);
    } else {
      var params = angular.isUndefined(this.item.params) ? {} : this.item.params;
      if (angular.isDefined(this.item.openInNewTab) && this.item.openInNewTab === true) {
        const url = this.$state.href(this.item.state, params);
        this.$window.open(url, '_blank');
      } else {
        this.$state.go(this.item.state, params);
      }
    }
    this.item.active = true;
    this.$mdSidenav('site-left').close();
  }

}

angular
  .module('triangular.components')
  .component('triMenuItem', {
    require: {
      triMenu: '^triMenu'
    },
    bindings: {
      item: '<'
    },
    template: '<div ng-include="$ctrl.item.template"></div>',
    controller: AgentAvatarCtrl
  });
